import { createStorageManager } from "app/pages/sales-intelligence/services/storage-manager/factory";

const localStorageManager = createStorageManager(window.localStorage, (key) => `si:industry:${key}`);

export const industryStorage = localStorageManager.configList({
    /**
     * Whether the viewer has dismissed the Industry Plus launch banner. Stored per browser rather than per
     * account: a second `/account-settings` key would add a second serial fetch to the SI root resolve (ADR-0013).
     */
    launchBannerDismissed: { key: "launch-banner-dismissed", defaultValue: false },
});
